import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['item', 'caret'];

  connect() {
    const el = this.element.querySelector('[data-toggle-class]');
    this.toggleClass = el?.dataset.toggleClass || 'tw-hidden';
  }

  toggle() {
    const items = this.itemTargets;

    if (this.hasCaretTarget) {
      const classList = this.caretTarget.classList;

      if (classList.contains('caret-up')) {
        classList.remove('caret-up');
        classList.add('caret-down');
      } else if (classList.contains('caret-down')) {
        classList.remove('caret-down');
        classList.add('caret-up');
      }
    }

    items.forEach((item) => {
      item.classList.toggle(this.toggleClass);
    });
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      const items = this.itemTargets;

      this.caretTarget.classList.remove('caret-down');
      this.caretTarget.classList.add('caret-up');

      items.forEach((item) => {
        item.classList.add(this.toggleClass);
      });
    }
  }
}
